import React from 'react';
import NavigationBar from '../Shared/NavigationBar';

const Blogs = () => {
    return ( 
        <div>
            <NavigationBar />
            <div className=" pt-20">
            <h1 className="text-center">Comming soon</h1>
            </div>
        </div>
     );
}
 
export default Blogs;